import { render, staticRenderFns } from "./movefunds.vue?vue&type=template&id=99589d66&"
import script from "./movefunds.vue?vue&type=script&lang=js&"
export * from "./movefunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports